import { render, staticRenderFns } from "./StorageCostModal.vue?vue&type=template&id=9714b80a"
import script from "./StorageCostModal.vue?vue&type=script&lang=js"
export * from "./StorageCostModal.vue?vue&type=script&lang=js"
import style0 from "./StorageCostModal.vue?vue&type=style&index=0&id=9714b80a&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports